
































import { Component, Vue, Prop } from "vue-property-decorator";
import Message from "./Message.vue";
import { Dictionary } from "vue-router/types/router";
import { authUser } from "@/auth/User.ts";
import EventBus from "../event-bus";

@Component({
  components: {
    message: Message
  }
})
export default class MessageStream extends Vue {
  @Prop()
  emergency: any;

  @Prop()
  chat: any;

  @Prop()
  operator: any;

  messageText = "";

  get messageList() {
    return this.chat || [];
  }

  loading: boolean = false;

  async loadMoreMessages() {
    let resp = null;
    try {
      this.loading = true;
      const last_message = this.chat[this.chat.length - 1];
      const last_id = last_message["id"];
      resp = await this.$http.get(
        `/emma/admin/emergencies/${this.emergency.id}/messages`,
        { params: { after: last_id, operator_id: this.operator } }
      );
      resp.data.forEach((el: any) => (el.is_sent = el.user_id == authUser.id));
      this.chat.push(...resp.data);
    } catch (e) {
    } finally {
      if (resp && resp.data.length == 0) this.loading = true;
      else this.loading = false;
    }
  }

  sendMessage() {
    var formData = new FormData();
    formData.append("title", '');
    formData.append("body", this.messageText);
    formData.append("dest_id", this.operator );
    this.$http.post(`/emma/admin/emergencies/${this.emergency.id}/messages`, formData ).then( resp => {
        this.messageList.unshift({
            id: resp.data.id,
            title: '',
            user_full_name: authUser.full_name,
            user_id: authUser.id,
            body: this.messageText,
            timestamp: Date.now() / 1000,
            is_sent: true
        })
        this.messageText = '';
    }).catch( () => {

    });
  }
}
